module.exports = __webpack_public_path__ + "img/icon_pantalla_manejo_de_referidos_mipe.2d9e9658.svg";